export default __webpack_public_path__ + "static/media/h2.ab052ae1.jpg";